import { CheckboxField } from '@cian/components';
import * as React from 'react';

import { IJsonQuery } from '../../../json_query';
import { isInNewNeighborsButtonGroup } from '../../../utils/experiments/filtersUx';
import { getTermValue } from '../../../json_query/reducers/helpers';
import { ILocation } from '../../../api/locations';
import { IExperiment } from '../../../api/experiments';
import { FOfferType, offerTypeFromJsonQuery } from '../../../utils/category';
import { locationHasNeighbors } from '../../../utils/neighbors';

const styles = require('./WithNeighbors.css');

export interface IWithNeighborsStateProps {
  jsonQuery: IJsonQuery;
  availableOfferType: FOfferType;
  currentLocation: ILocation | 'moscow_mo' | 'spb_lo';
  experiments: IExperiment[];
}

export interface IWithNeighborsDispatchProps {
  onWithNeighborsChanged(withNeighbors: boolean): void;
}

export type TWithNeighborsProps = IWithNeighborsStateProps & IWithNeighborsDispatchProps;

export function getValue(value: boolean = true) {
  return value;
}

export class WithNeighbors extends React.Component<TWithNeighborsProps> {
  public render() {
    const { jsonQuery, onWithNeighborsChanged } = this.props;

    if (!this.isAvailable()) {
      return null;
    }

    const withNeighbors = getValue(getTermValue('with_neighbors')(jsonQuery));

    return (
      <div className={styles['container']}>
        <CheckboxField label="Рядом с городом" value={withNeighbors} onValueChange={onWithNeighborsChanged} />
      </div>
    );
  }

  private isAvailable() {
    const { jsonQuery, availableOfferType, currentLocation, experiments } = this.props;

    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const hasNeighbors = locationHasNeighbors(currentLocation);

    return (offerType & availableOfferType) !== 0 && hasNeighbors && isInNewNeighborsButtonGroup(experiments);
  }
}
